import React from 'react';
import { Wrench } from '../design/Icons';

// Placeholder renderer for routes that haven't been migrated yet.
// Uses the new design tokens so the skeleton already matches the final look.

const StubPage = ({ title, description, section }) => (
  <div style={{ padding: 18, maxWidth: 920 }}>
    <div className="page-title-row">
      <div>
        {section && <div className="label">{section}</div>}
        <h1 className="page-title">{title}</h1>
        {description && <div className="page-sub num">{description}</div>}
      </div>
    </div>

    <div className="panel" style={{ marginTop: 18 }}>
      <div className="panel-head">
        <span className="title">Migration in progress</span>
        <span className="label">Placeholder</span>
      </div>
      <div style={{ padding: 24, color: 'var(--ink-3)', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        <Wrench size={18} />
        <div>
          <div style={{ color: 'var(--ink-2)', fontWeight: 500, marginBottom: 4 }}>
            This screen hasn't been ported to the new design yet.
          </div>
          <div className="label" style={{ letterSpacing: '0.08em' }}>
            The nav, data, and auth layers are already the new build - only the
            screen body is pending. It will replace this panel in the next phase.
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default StubPage;
